module.exports = __webpack_public_path__ + "static/media/duvar.903fea80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/duvar.png
// module id = 47
// module chunks = 0